export const TAB_CONTENT_PT_BR = {
	consolidated: "Consolidados",
	extract: "Extrato",
};

export type TabContentTranslations = typeof TAB_CONTENT_PT_BR;
